export default "__VITE_ASSET__BpoFl051__"